import type {IntegrationsType, PricingChannels, ReservationSource} from "../../constant";
import type {PriceSource} from "../model/listing";

const getChannelLabel = (
    channel: ReservationSource | IntegrationsType | PricingChannels | PriceSource
) => {
    if (channel === "HomeAway") {
        return "VRBO";
    }
    if (channel === "ChannelConnector") {
        return "Other Channel";
    }
    if (channel === "direct") {
        return "Direct";
    }
    return channel;
};
export default getChannelLabel;
